import styled from 'styled-components';

export default styled.div`
  display: flex;
  height: 550px;
  border-radius: 4px;
  border: 1px solid #CCCCCC;

  label {
    margin-bottom: 0px;
  }

  .header {
    margin-bottom: 0px;
  }

  .trade-relationship {
    flex: 1;
  }

  .sider {
    width: 300px;
    border-left: 1px solid #CCCCCC;

    .body {
      padding: 14px 12px;
      max-height: 510px;
      overflow-y: auto;

      a {
        display: flex;

        .ant-btn {
          flex: 1;
        }
      }

      .section-label {
        color: #001529 !important;
        font-size: 14px !important;
      }

      .view-assessment {
        background: white;
        color: #001529;
        margin-bottom: var(--size-lg);
      }

      .title {
        font-weight: 700;
        font-size: 11px;
      }

      .label {
        font-weight: 500;
        font-size: 18px;
        margin-bottom: var(--size-lg);
      }

      .section-label {
        color: #6B6B6B;
        font-weight: 700;
        font-size: 12px;
      } 

      .sources {
        margin-top: 12px;

        .source {
          display: flex;
          padding: 12px 0px;
          border-top: 1px solid #F0F0F0;

          .left {
            flex: 1;
            display: flex;
            gap: 12px;

            .default-content {
              justify-content: center;

              label {
                font-weight: 500;
                font-size: 14px;
                color: #001529;
              }
            }

            .legend {
              width: 10px;
              height: 10px;
              border-radius: 100%;

              &.sca {
                background: #52C41A;
              }

              &.is {
                background: #FF7875;
              }
            }

            svg {
              fill: #FFC700;
            }
          }

          button {
            svg {
              margin-top: -4px;
            }
          }

          &:last-of-type {
            border-bottom: 1px solid #F0F0F0;
          }
        }
      }
    }
  }
`;
